"use client";

import React, { useEffect } from "react";
import type { ReactElement } from "react";

function RootError({
  error,
  reset,
}: Readonly<{
  error: Error & { digest?: string };
  reset: () => void;
}>): ReactElement {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="relative flex justify-center items-center h-[calc(100vh-56px)] overflow-hidden">
      <header className="relative z-10 flex flex-col gap-2 max-w-md text-center">
        <h1 className="text-2xl font-semibold p-1 animate__animated animate__slideInUp animate__faster">
          Oops
        </h1>
        <hr className="border-0 h-px bg-linear-to-r from-transparent via-gray-200 to-transparent" />
        <div className="flex flex-col animate__animated animate__fadeIn animate__faster delay-0.5s p-1">
          <p className="text-sm leading-tight">
            Something went wrong. Please try again later.
          </p>
          <button
            onClick={(): void => {
              reset();
            }}
            type="button"
          >
            Try again
          </button>
        </div>
      </header>
    </div>
  );
}

export default RootError;
